<template>
  <div>
    <div class="recent" id="recent" v-if="start">
      <a id="back" @click="back()">戻る</a>
      <h2>受賞作品</h2>
      <div>タイトルを押すことでその作品を読むことができます。</div>
      <br />
      <div id="leftleft" class="boxex" v-if="isGet">
        <div v-for="(id, index) in awardIds" :key="id">
          <div class="boxes">
            <h3 class="award">{{awardName[index]}}</h3>
            <div class="box">
              <div class="pen">
                <small>ペンネーム:{{items[id].name}}</small>
              </div>
              <div class="title">
                <a
                  @click="showbody(id,index,items[id].name,items[id].title,items[id].goodarray)"
                >{{items[id].title}}</a>
              </div>
              <hr style="margin: 0em;" />
              <p class="texts">{{items[id].intro}}</p>
              <div>
                <small>
                  <hr style="margin: 0em;margin-bottom:0.2em;" />
                  <span class="info">
                    タグ:
                    {{items[id].tags?items[id].tags.join(','):"タグなし"}}
                  </span>
                  <br />
                  <span class="info">いいね:{{(items[id].goodarray||[]).length}}件</span>
                </small>
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
      <div v-if="!isGet">ちょっと待ってね。今準備してるよ。</div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Recent",
  props: {},
  data: () => ({
    start: true,
    offline: false,
    isGet: false,
    loading: false,
    dotCount: 0,
    dottime: null,
    ids: [],
    awardIds: [
      "-M6Ixuc0MIM9no4xw4T5",
      "-M6UPcRE7ag_jFRWJbMW",
      "-M6seS8MJLVxx4ma0x0H",
      "-M7TmEvMOa6sm_0OkmRM",
      "-M7XrgN4Tcpzna40R9iQ",
      "-M702sBT7vBCsVNwpfTw"
    ],
    awardName: ["金賞", "銀賞", "銀賞", "銅賞", "銅賞", "銅賞"],
    items: {}
  }),
  created() {
    // view が作られた時にデータを取得し、
    // そのデータは既に監視されています
    this.fetchData();
    this.onlinecheck();
  },
  watch: {
    // ルートが変更されたらこのメソッドを再び呼び出します
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      this.loading = true;
      firebase
        .database()
        .ref("/intros")
        .once("value")
        .then(snapshot => {
          this.items = snapshot.val();
          for (var id in this.items) {
            if (this.items[id].test !== true) {
              this.ids.push(id);
            }
          }
          this.ids = this.ids.reverse();
          this.isGet = true;
        })
        .catch(reason => {
          alert(reason);
        });
    },
    onlinecheck() {
      var connectedRef = firebase.database().ref(".info/connected");
      connectedRef.on("value", snap => {
        if (snap.val() === true) {
          this.offline = false;
          clearInterval(this.dottime);
        } else {
          this.offline = true;
          this.dottime = setInterval(() => {
            this.dotCount = (this.dotCount + 1) % 6;
          }, 500);
        }
      });
    },
    showbody(id, index, name, title, goodarray) {
      this.$router.push({
        name: "awardbody",
        params: {
          id: id,
          content: {
            name: name,
            title: title,
            goodarray: goodarray || []
          },
          award: this.awardName[index]
        }
      });
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
}
#recent {
}
.tag {
  display: inline-block;
  margin-right: 20px;
}
#leftleft {
  text-align: left;
}
.boxes {
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  max-width: 900px;
}
.box {
  border-style: solid;
  border-color: black;
  border-width: thin;
  height: min-content;
}
.pen {
  padding-left: 2%;
  padding-right: 2%;
  margin-bottom: 5px;
}
.award {
  vertical-align: middle;
  padding-left: 4%;
  padding-right: 4%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
.title {
  vertical-align: middle;
  padding-left: 4%;
  padding-right: 4%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
.info {
  padding-left: 2%;
  padding-right: 2%;
}
.texts {
  margin-top: 0.1em;
  padding-left: 2%;
  padding-right: 2%;
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
}
a {
  color: #42b983;
  cursor: pointer;
}
#back {
  margin-right: 80%;
  text-align: center;
}
</style>
